export const APPLICATION_LOG_CONFIGURATIONS = "applicationLogConfigurations"
export const APPLICATION_LOG_CONFIGURATION_TYPE = "applicationLogConfigurationType"
export const APPLICATION_LOG_CONFIGURATIONS_REQUEST_STATUS = "applicationLogConfigurationRequestStatus"
